import React, { useContext } from 'react';
import { FormControlLabel, Checkbox, Button, Grid, GridSize, Typography } from '@mui/material';
import { SelectOption } from '../../../sharedModules/form/model';
import TextInput from '../../../sharedModules/form/components/TextInput';
import SelectInput from '../../../sharedModules/form/components/SelectInput';
import { RebatesContext } from '../contexts/RebatesContext';

export interface FilterProps {
  label: string;
  pluralLabel: string;
  selector: string;
  width: boolean | GridSize;
  type: string;
  optionSelector: string;
  options?: SelectOption[];
}

interface RebateFilterBarProps {
  filterValues?: any;
  setFilterValues?: any;
}

const RebateFilterBar: React.FC<RebateFilterBarProps> = (props) => {
  const { filterValues, setFilterValues } = props;

  const { fetchRebates } = useContext(RebatesContext);

  const handleApplyFilters = async () => {
    fetchRebates(filterValues);
  };

  const handleFiltersKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      handleApplyFilters();
    }
  };

  return (
    <Grid container spacing={1} alignItems="flex-start" onKeyDown={handleFiltersKeyPress}>
      <Grid item xs={12} md={2}>
        <SelectInput
          value={filterValues?.name}
          choices={[
            { label: 'Equipment', value: 'equipment' },
            { label: 'Installation', value: 'installation' },
          ]}
          onChange={(value) => setFilterValues({ ...filterValues, name: value })}
          label="Category"
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <TextInput
          label="Zip Code"
          value={filterValues.zip}
          shrinkLabel
          valueChanged={(value: string) => setFilterValues({ ...filterValues, zip: value })}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <SelectInput
          value={filterValues?.online_status}
          onChange={(value) => setFilterValues({ ...filterValues, online_status: value })}
          label="Manufactuer"
          defaultChoice={{ label: 'All', value: 'status__all' }}
          choices={[
            { label: 'Trane', value: 'Offline' },
            { label: 'Carrier', value: 'Online' },
          ]}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <TextInput
          value={filterValues?.minimum_size}
          shrinkLabel
          valueChanged={(value: string) => setFilterValues({ ...filterValues, minimum_size: value })}
          label="Minimum Asset Size"
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <TextInput
          value={filterValues?.maximum_size}
          shrinkLabel
          valueChanged={(value: any) => setFilterValues({ ...filterValues, maximum_size: value })}
          label="Maximum Asset Size"
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <Button
          variant="contained"
          color="primary"
          style={{ color: '#fff', marginTop: 19 }}
          disableElevation
          onClick={() => {
            handleApplyFilters();
          }}
        >
          Apply
        </Button>
      </Grid>
    </Grid>
  );
};

export default RebateFilterBar;
